import { useCallback } from 'react';

export const useItemDisplay = () => {
    const formatTitle = useCallback((name?: string) => {
        if (!name) {
            return '';
        }
        return name.replace(/BYO Market Plate/g, 'Build Your Own Market Plate');
    }, []);

    return {
        formatTitle
    };
};

export default useItemDisplay;
